import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    // Returns an HTML string; Angular's [innerHTML] sanitizer strips unsafe content.
    return marked.parse(value, { async: false, gfm: true, breaks: true }) as string;
  }

}
